import { initBootstrapSelect } from '../../Shared/js/vendor/deferred';

// HACK: async/await doesn't work with jQuery here for some reason
wo$(() =>
    initBootstrapSelect().then(() => {
        var defaultCriteria = {
            brand: null,
            phoneShortUrl: null,
            filter: '',
            sortBy: 'popular'
        };

        var controller = {
            show: function (selectedHandler, brandShortUrl, phoneShortUrl) {
                controller.init(selectedHandler, null, brandShortUrl, phoneShortUrl);

                controller.byoPhoneModal.modal('show');
            },

            initModel: function () {
                controller.byoPhoneSelectedHandler = null;
                controller.pageHeight = null;
                controller.currentStep = null;
                controller.byoPhones = [];
                controller.maxByoPhones = 16;
                controller.filteredByoPhones = [];
                controller.criteria = wo$.extend(true, {}, defaultCriteria);
                controller.stepsConfig = [];
                controller.steps = null;
                controller.currentStepIndex = null;
                controller.selectedPhone = null;

                controller.wizardSteps = [];
                controller.wizardSteps.push(0);
                controller.wizardSteps.push(1);
                controller.wizardSteps.push(2);
                controller.wizardSteps.push(3);
            },

            init: function (selectedHandler, parentElement, brandShortUrl, phoneShortUrl) {
                if (parentElement) {
                    controller.byoPhoneModal = parentElement;
                    controller.isEmbedded = true;
                } else {
                    controller.byoPhoneModal = wo$('#modal-byo-phone-picker');
                    controller.isEmbedded = false;
                }

                if (!controller.byoPhoneModal.length) return;

                controller.modalData = WhistleOut.readLookupData(controller.byoPhoneModal, true);

                WhistleOut.applySelectPicker(controller.byoPhoneModal.find('.selectpicker'));

                controller.initModel();

                if (controller.isEmbedded) {
                    controller.byoPhoneModal.find('div.bootstrap-select button').addClass('btn-sm');
                }

                controller.stepsConfig = controller.modalData.stepsConfig;
                controller.criteria.brand = null;
                controller.criteria.phoneShortUrl = null;
                controller.selectedPhone = null;
                controller.byoPhones = controller.modalData.byoPhones;
                controller.filteredByoPhones = controller.byoPhones.slice().sort(function (a, b) {
                    if (a.rank < b.rank) return -1;
                    if (a.rank > b.rank) return 1;
                    return 0;
                });

                controller.byoPhoneSelectedHandler = selectedHandler;

                controller.steps = controller.wizardSteps;

                controller.byoPhoneModal
                    .find('[data-brand-button]')
                    .off()
                    .click(function () {
                        var brandShortUrl = wo$(this).data('brand-button');
                        controller.criteria.brand = brandShortUrl;
                        controller.criteria.phoneShortUrl = null;
                        controller.criteria.filter = '';
                        controller.selectedPhone = null;
                        controller.setCurrentStep(controller.currentStepIndex + 1);
                    });

                controller.byoPhoneModal
                    .find('[data-show-all-byod]')
                    .off()
                    .click(function () {
                        controller.byoPhoneModal.modal('hide');
                        controller.byoPhoneSelectedHandler(null, controller.modalData.generalSearchUrl);
                    });

                controller.byoPhoneModal
                    .find('[data-back-button]')
                    .off()
                    .click(function () {
                        controller.setCurrentStep(controller.currentStepIndex - 1);
                    });

                controller.byoPhoneModal.on('hidden.bs.modal', function () {
                    controller.cleanup();
                });

                controller.byoPhoneModal.on('shown.bs.modal', function () {
                    controller.pageHeight = wo$(window).height();
                });

                if (brandShortUrl && phoneShortUrl) {
                    controller.criteria.brand = brandShortUrl;
                    controller.criteria.phoneShortUrl = phoneShortUrl;
                    controller.setCurrentStep(2);
                } else {
                    controller.setCurrentStep(0);
                }
                controller.filterByoPhones();

                WhistleOut.applySelectPickersStyle(controller.byoPhoneModal);
            },

            phoneExist: function (shortUrl) {
                return (
                    controller.byoPhones.filter(function (p) {
                        return p.shortUrl === shortUrl;
                    }).length > 0
                );
            },

            cleanup: function () {
                controller.maxByoPhones = 16;
                controller.currentStepIndex = null;
                controller.criteria = wo$.extend(true, {}, defaultCriteria);
                controller.byoPhoneModal.off();
            },

            setCurrentStep: function (stepIndex) {
                controller.maxByoPhones = 16;

                if (controller.currentStepIndex != null) {
                    // If not initial load
                    controller.saveToCriteria();
                }

                controller.currentStepIndex = stepIndex;
                controller.currentStep = controller.stepsConfig[controller.steps[stepIndex]];
                controller.byoPhoneModal.find('[data-step]').hide();
                controller.byoPhoneModal.find('[data-step-number]').text(stepIndex + 1);
                controller.byoPhoneModal.find('[data-step-title]').text(controller.currentStep.title);

                controller.byoPhoneModal.find('[data-step-header]').hide();
                controller.byoPhoneModal.find('[data-step-header="' + stepIndex + '"]').show();

                if (stepIndex === 0) {
                    controller.byoPhoneModal.find('[data-back-button]').hide();
                } else {
                    controller.byoPhoneModal.find('[data-back-button]').show();
                }

                controller.loadFromCriteria();

                controller.byoPhoneModal.find('[data-step="' + controller.currentStep.name + '"]').show();
            },

            loadFromCriteria: function () {
                if (controller.currentStep.name === 'phone') {
                    controller.showByoPhones();

                    controller.byoPhoneModal
                        .find('[data-step="' + controller.currentStep.name + '"] #load-more-byo-phones')
                        .off()
                        .click(function () {
                            controller.maxByoPhones += 16;
                            controller.showByoPhones(true);

                            var maxItems = controller.maxByoPhones;
                            if (controller.filteredByoPhones.length <= maxItems) {
                                controller.byoPhoneModal
                                    .find('[data-step="' + controller.currentStep.name + '"] #load-more-byo-phones')
                                    .hide();
                            } else {
                                controller.byoPhoneModal
                                    .find('[data-step="' + controller.currentStep.name + '"] #load-more-byo-phones')
                                    .show();
                            }
                        });
                    var maxItems = controller.maxByoPhones;
                    if (controller.filteredByoPhones.length <= maxItems) {
                        controller.byoPhoneModal
                            .find('[data-step="' + controller.currentStep.name + '"] #load-more-byo-phones')
                            .hide();
                    } else {
                        controller.byoPhoneModal
                            .find('[data-step="' + controller.currentStep.name + '"] #load-more-byo-phones')
                            .show();
                    }

                    controller.byoPhoneModal
                        .find('[data-step="' + controller.currentStep.name + '"] #sort-dropdown')
                        .off('change', controller.updateByoPhonesFilters)
                        .on('change', controller.updateByoPhonesFilters);

                    controller.byoPhoneModal
                        .find('[data-step="' + controller.currentStep.name + '"] #byo-phone-search')
                        .val(controller.criteria.filter);
                    controller.byoPhoneModal
                        .find('[data-step="' + controller.currentStep.name + '"] #byo-phone-search')
                        .off()
                        .keyup(function () {
                            controller.updateByoPhonesFilters(true);
                        });

                    controller.bindChoosePhoneButtons();
                } else if (controller.currentStep.name === 'model') {
                    controller.showByoPhoneModels();
                    controller.bindChoosePhoneModelButtons();

                    var popoverButtons = controller.byoPhoneModal.find('[data-content]');
                    popoverButtons.popover();
                    popoverButtons.off('shown.bs.popover').on('shown.bs.popover', function () {
                        wo$('[data-show-all-byod]')
                            .off()
                            .click(function () {
                                popoverButtons.popover('destroy');
                                controller.byoPhoneModal.modal('hide');
                                controller.byoPhoneSelectedHandler(null, controller.modalData.generalSearchUrl);
                            });
                    });
                } else if (controller.currentStep.name === 'networks') {
                    controller.showNetworkCompatiblity();
                    controller.bindSelectButton();
                }
            },

            bindChoosePhoneButtons: function () {
                controller.byoPhoneModal
                    .find('[data-phone-button]')
                    .off()
                    .click(function () {
                        var phoneShortUrl = wo$(this).data('phone-short-url');
                        controller.criteria.phoneShortUrl = phoneShortUrl;
                        controller.setCurrentStep(controller.currentStepIndex + 1);
                    });
            },

            bindChoosePhoneModelButtons: function () {
                controller.byoPhoneModal
                    .find('[data-model]')
                    .off()
                    .click(function () {
                        var model = wo$(this).data('model');
                        var modelId = wo$(this).data('model-id');
                        var searchUrl = wo$(this).data('search-url');
                        controller.selectedPhone.selectedModel = model;
                        controller.selectedPhone.selectedModelId = modelId;
                        controller.selectedPhone.searchUrl = searchUrl;
                        controller.setCurrentStep(controller.currentStepIndex + 1);
                    });
            },

            bindSelectButton: function () {
                controller.byoPhoneModal
                    .find('[data-select]')
                    .off()
                    .click(function () {
                        controller.byoPhoneModal.modal('hide');
                        controller.byoPhoneSelectedHandler(controller.selectedPhone);
                    });
            },

            updateByoPhonesFilters: function (noAnimation) {
                if (noAnimation !== true) {
                    noAnimation = false;
                }
                controller.maxByoPhones = 16;
                controller.saveToCriteria();
                controller.showByoPhones(null, noAnimation);
                var maxItems = controller.maxByoPhones;
                if (controller.filteredByoPhones.length <= maxItems) {
                    controller.byoPhoneModal
                        .find('[data-step="' + controller.currentStep.name + '"] #load-more-byo-phones')
                        .hide();
                } else {
                    controller.byoPhoneModal
                        .find('[data-step="' + controller.currentStep.name + '"] #load-more-byo-phones')
                        .show();
                }
            },

            showByoPhones: function (append, noAnimation) {
                var panel = controller.byoPhoneModal.find(
                    '[data-step="' + controller.currentStep.name + '"] [data-byo-phones-panel]'
                );
                var startFrom = 0;

                if (append) {
                    var currentlyShowing = controller.byoPhoneModal.find(
                        '[data-step="' +
                            controller.currentStep.name +
                            '"] [data-byo-phones-panel] [data-phone-short-url]'
                    ).length;
                    startFrom = currentlyShowing;
                } else {
                    panel.html('');
                }

                var maxItems = controller.maxByoPhones;
                wo$.each(controller.filteredByoPhones, function (index, phone) {
                    if (index >= maxItems) return;

                    if (index >= startFrom) {
                        controller.insertByoPhoneItem(phone, panel, noAnimation);
                    }
                });

                controller.bindChoosePhoneButtons();
            },

            showByoPhoneModels: function (noAnimation) {
                var panel = controller.byoPhoneModal.find(
                    '[data-step="' + controller.currentStep.name + '"] [data-byo-phone-models-panel]'
                );

                panel.html('');

                var currentPhone = controller.byoPhones.filter(function (p) {
                    return p.shortUrl && p.shortUrl.toLowerCase() === controller.criteria.phoneShortUrl.toLowerCase();
                })[0];

                controller.selectedPhone = currentPhone;

                controller.byoPhoneModal.find('[data-phone-name-span]').html(controller.selectedPhone.name);
                controller.byoPhoneModal.find('[data-phone-img]').prop('alt', controller.selectedPhone.name);
                controller.byoPhoneModal
                    .find('[data-phone-img]')
                    .prop('src', controller.selectedPhone.imageUrl.extraExtraLarge + '?w=300');

                controller.byoPhoneModal.find('[data-mobilev-phone-img]').prop('alt', controller.selectedPhone.name);
                controller.byoPhoneModal
                    .find('[data-mobilev-phone-img]')
                    .prop('src', controller.selectedPhone.imageUrl.extraExtraLarge + '?w=100');

                if (controller.selectedPhone.shortUrl.toLowerCase().startsWith('google-pixel')) {
                    controller.byoPhoneModal.find('[data-find-model]').hide();
                    controller.byoPhoneModal.find('[data-find-model-iphone]').hide();
                    controller.byoPhoneModal.find('[data-find-model-android]').hide();
                    controller.byoPhoneModal.find('[data-find-model-pixel]').show();
                } else if (
                    controller.selectedPhone.operatingSystemShortUrl &&
                    controller.selectedPhone.operatingSystemShortUrl.toLowerCase() === 'android'
                ) {
                    controller.byoPhoneModal.find('[data-find-model]').hide();
                    controller.byoPhoneModal.find('[data-find-model-iphone]').hide();
                    controller.byoPhoneModal.find('[data-find-model-android]').show();
                    controller.byoPhoneModal.find('[data-find-model-pixel]').hide();
                } else if (
                    controller.selectedPhone.operatingSystemShortUrl &&
                    controller.selectedPhone.operatingSystemShortUrl.toLowerCase() === 'apple-ios'
                ) {
                    controller.byoPhoneModal.find('[data-find-model]').hide();
                    controller.byoPhoneModal.find('[data-find-model-android]').hide();
                    controller.byoPhoneModal.find('[data-find-model-iphone]').show();
                    controller.byoPhoneModal.find('[data-find-model-pixel]').hide();
                } else {
                    controller.byoPhoneModal.find('[data-find-model-android]').hide();
                    controller.byoPhoneModal.find('[data-find-model-iphone]').hide();
                    controller.byoPhoneModal.find('[data-find-model]').show();
                    controller.byoPhoneModal.find('[data-find-model-pixel]').hide();
                }

                wo$.each(currentPhone.models, function (index, model) {
                    controller.insertByoPhoneModelItem(model, panel, noAnimation);
                });

                if (controller.selectedPhone.is5GCapable) {
                    controller.byoPhoneModal.find('[data-has-5g]').show();
                } else {
                    controller.byoPhoneModal.find('[data-has-5g]').hide();
                }
            },

            showNetworkCompatiblity: function () {
                controller.byoPhoneModal.find('[data-phone-model-span]').html(controller.selectedPhone.selectedModel);

                var selectedModel = controller.selectedPhone.models.filter(function (m) {
                    return m.id === controller.selectedPhone.selectedModelId;
                })[0];

                for (var i = 0; i < selectedModel.compatibilities.length; i++) {
                    var networkCompatibility = selectedModel.compatibilities[i];

                    controller.setCompatibilitySpan(
                        controller.byoPhoneModal.find(
                            '[data-' +
                                networkCompatibility.networkId +
                                '-' +
                                networkCompatibility.networkTypeId +
                                '-compatibility]'
                        ),
                        networkCompatibility.compatibility
                    );
                }
            },

            setCompatibilitySpan: function (span, compatibility) {
                if (compatibility === 1) {
                    span.removeClass().addClass('fa fa-downloads-0');
                    span.html('');
                } else if (compatibility === 2) {
                    span.removeClass().addClass('fa fa-downloads-2');
                    span.html('');
                } else if (compatibility === 3) {
                    span.removeClass().addClass('fa fa-downloads-4');
                    span.html('');
                } else {
                    span.removeClass().addClass('c-gray-light');
                    span.html('-');
                }
            },

            insertByoPhoneItem: function (phone, panel, noAnimation) {
                var phoneTemplateHtml = controller.byoPhoneModal
                    .find('[data-step="' + controller.currentStep.name + '"] #byo-phone-item-template')
                    .html();

                phoneTemplateHtml = phoneTemplateHtml.replace('{{button-data}}', 'data-choose-button');

                phoneTemplateHtml = phoneTemplateHtml.replace(/{{SHORT-URL}}/g, phone.shortUrl);
                phoneTemplateHtml = phoneTemplateHtml.replace(/{{IMAGE-URL}}/g, phone.imageUrl.medium);
                phoneTemplateHtml = phoneTemplateHtml.replace(/{{NAME}}/g, phone.name);

                var li = wo$(phoneTemplateHtml);

                if (phone.is5GCapable) {
                    li.find('[data-has-5g]').show();
                } else {
                    li.find('[data-has-5g]').hide();
                }

                if (noAnimation) {
                    panel.append('\n\t');
                    li.appendTo(panel).show();
                } else {
                    panel.append('\n\t');
                    li.appendTo(panel).fadeIn('medium');
                }
            },

            insertByoPhoneModelItem: function (model, panel, noAnimation) {
                var phoneModelTemplateHtml = controller.byoPhoneModal
                    .find('[data-step="' + controller.currentStep.name + '"] #byo-phone-model-item-template')
                    .html();

                phoneModelTemplateHtml = phoneModelTemplateHtml.replace(/{{MODEL}}/g, model.model);
                phoneModelTemplateHtml = phoneModelTemplateHtml.replace(/{{MODEL-ID}}/g, model.id);
                phoneModelTemplateHtml = phoneModelTemplateHtml.replace(/{{SEARCH-URL}}/g, model.searchUrl);

                var li = wo$(phoneModelTemplateHtml);

                if (noAnimation) {
                    panel.append('\n\t');
                    li.appendTo(panel).show();
                } else {
                    panel.append('\n\t');
                    li.appendTo(panel).fadeIn('medium');
                }
            },

            saveToCriteria: function () {
                if (controller.currentStep.name === 'phone') {
                    controller.criteria.sortBy = controller.byoPhoneModal
                        .find('[data-step="' + controller.currentStep.name + '"] #sort-dropdown')
                        .selectpicker('val');
                    controller.criteria.filter = controller.byoPhoneModal
                        .find('[data-step="' + controller.currentStep.name + '"] #byo-phone-search')
                        .val();
                }

                controller.filterByoPhones();
            },

            filterBrand: function (p) {
                if (!controller.criteria.brand || controller.criteria.brand.length < 1) {
                    return true;
                }
                if (
                    p.manufacturerShortUrl &&
                    controller.criteria.brand.toLowerCase() === p.manufacturerShortUrl.toLowerCase()
                ) {
                    return true;
                }
                return false;
            },

            filterSearch: function (p) {
                if (p.id === -1) return true;
                if (
                    controller.criteria.filter.length &&
                    p.name.toLowerCase().indexOf(controller.criteria.filter.toLowerCase()) < 0
                ) {
                    return false;
                }
                return true;
            },

            sortByoPhones: function (a, b) {
                if (controller.criteria.sortBy === 'popular') {
                    if (a.rank < b.rank) return -1;
                    if (a.rank > b.rank) return 1;
                    return 0;
                } else if (controller.criteria.sortBy === 'model') {
                    if (a.name < b.name) return -1;
                    if (a.name > b.name) return 1;
                    return 0;
                }
                if (a.rank < b.rank) return -1;
                if (a.rank > b.rank) return 1;
                return 0;
            },

            filterByoPhones: function () {
                controller.filteredByoPhones = controller.byoPhones
                    .slice()
                    .filter(function (p) {
                        return controller.filterBrand(p) && controller.filterSearch(p);
                    })
                    .sort(controller.sortByoPhones);
            }
        };

        WhistleOut.byoPhonePickerController = controller;
    })
);
